import { Component, OnInit, Inject, PLATFORM_ID } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { isPlatformServer } from "@angular/common";
import { ProfileService, LocalService, AuthService } from "../../../core";

@Component({
  selector: "app-email-verify",
  templateUrl: "./email-verify.component.html",
  styleUrls: ["./email-verify.component.scss"],
})
export class EmailVerifyComponent implements OnInit {
  emailType;
  verificationToken;
  showError: boolean = false;
  showHomeRoute: boolean = false;
  showApprove: boolean = false;
  showDenied: boolean = false;
  isSalesManager: boolean = false;
  chalgStatus = "";
  chgVerificationToken;
  ChgApproveMsg = "";
  challengeName;
  notificationTypeId: number;
  emailNotificationTypeName: string = "";
  unsubscribeUserFlag: boolean = false;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    @Inject(PLATFORM_ID) private platformId: any,
    private profileService: ProfileService,
    private authService: AuthService
  ) {}

  showCommentSection: boolean = false;
  userComments: string = "";

  ngOnInit() {
    if (isPlatformServer(this.platformId)) {
      return;
    }
    this.emailType = this.route.snapshot.params["type"];
    this.verificationToken = this.route.snapshot.params["token"];
    this.chalgStatus = this.route.snapshot.params["status"];
    this.chgVerificationToken =
      this.route.snapshot.params["verification-token"];
    this.notificationTypeId = this.route.snapshot.params["notificationTypeId"];

    if (this.emailType === "verify") {
      this.verifyEmail();
    } else if (this.emailType === "approved" || this.emailType === "denied") {
      this.approveUserRole();
    } else if (this.chalgStatus != "" && this.chalgStatus != undefined) {
      //this.approveChallenge()
      this.showStatusAndCommentSection();
    } else if (this.notificationTypeId) {
      this.emailNotificationTypeName = "show";
      // this.getEmailNotificationType(); as of now no need to call this api as newsetter name not required to show
    } else {
      this.router.navigate(["/"]);
    }
  }

  approveUserRole() {
    this.profileService
      .approveUserRole(this.emailType, this.verificationToken)
      .subscribe(
        (data) => {
          if (data.roleToBeApproved.name === "SALES_MANAGER") {
            this.isSalesManager = true;
          } else if (data.roleToBeApproved.name === "SE_MANAGER") {
            this.isSalesManager = false;
          }
          this.showApprove = this.emailType === "approved";
          this.showDenied = this.emailType === "denied";
          // if (['200', '226 - IM_USED'].indexOf(data.status) >= 0) {
          // }
        },
        (err) => {
          // this.verificationMessage = err.msg;
          this.showError = true;
        }
      );
  }

  showStatusAndCommentSection() {
    this.showCommentSection = true;
  }

  approveChallenge() {
    let reqParams = {
      verificationToken: this.chgVerificationToken,
      status: this.chalgStatus.toUpperCase(),
      comments: this.userComments,
      approverCcoId: "",
    };
    this.profileService.approveChallenge(reqParams).subscribe(
      (data) => {
        if (data.tokenCheck == "SUCCESS") {
          this.showCommentSection = false;
          this.challengeName = data.customChallenge.name;
          this.ChgApproveMsg =
            "Thank you! Your approval decision for the sales challenge <strong>" +
            this.challengeName +
            "</strong> is successfully submitted.";
        }
        if (data.tokenCheck == "ALREADY_USED") {
          this.showCommentSection = false;
          this.challengeName = data.customChallenge.name;
          this.ChgApproveMsg =
            "<strong>Oops!</strong> This approval link is no longer valid.";
        }
      },
      (err) => {
        // this.verificationMessage = err.msg;
        this.showError = true;
        this.showCommentSection = false;
      }
    );
  }

  verifyEmail() {
    this.profileService.verifyEmail(this.verificationToken).subscribe(
      (data) => {
        this.showHomeRoute = true;
        // if (data.status === '200' || data.status === '226 - IM_USED') {
        // }
      },
      (err) => {
        // this.verificationMessage = err.msg;
        this.showError = true;
      }
    );
  }

  getEmailNotificationType() {
    //api call
    this.profileService
      .getEmailNotificationType(this.notificationTypeId)
      .subscribe((response) => {
        this.emailNotificationTypeName = response.name;
      });
  }

  unsubscribeUser() {
    let param = "?notificationTypeId=" + this.notificationTypeId;

    this.profileService.unsubscribeUser(param).subscribe((response) => {
      if (response) {
        this.unsubscribeUserFlag = true;
      }
    });
  }

  contactSupport() {
    this.router.navigateByUrl("/support");
  }

  logoutUser() {
    LocalService.flush("token");
    LocalService.flush("userProfile");
    LocalService.flush("selectedLanguage");
    LocalService.flush("selectedFile");
    this.authService.clearAll();
    window.location.href = "/";
  }
}
